import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface MyAccountServiceResponse {
  my_account_page_schema: any;
  my_account_page_data: any;
  my_account_page_service_id?: string;
  my_account_page_translations?: any;
}

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {
  private readonly baseUrl: string = environment.BASE_URL;

  constructor(private readonly http: HttpClient) {}

  loadData(): Observable<MyAccountServiceResponse> {
    const url = `${this.baseUrl}api/v1/my-account-service/`;
    return this.http.get<MyAccountServiceResponse>(url);
  }
}
